import styled, { keyframes } from "styled-components";

const slideInRight = keyframes`
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
`;

export const PaginaClienteContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 600px;
  height: 100vh;
  background: #1c1c1c;
  z-index: 1500;
  display: flex;
  flex-direction: column;
  box-shadow: -10px 0px 30px rgba(0, 0, 0, 0.5);
  animation: ${slideInRight} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const Header = styled.header`
  padding: 20px 30px;
  background: #252525;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 24px;
  }
`;

export const MainContent = styled.main`
  padding: 30px;
  overflow-y: auto;
  flex-grow: 1;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoBox = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 6px;

  label {
    display: block;
    font-size: 12px;
    color: #fff;
    opacity: 0.6;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  input {
    width: 100%;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 16px;
    padding: 0;
    &:focus {
      outline: none;
    }
    &[readonly] {
      opacity: 0.8;
    }
  }

  .value {
    color: #fff;
    font-size: 16px;
  }
`;

export const ActionBox = styled(InfoBox)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .value {
    font-weight: 600;
    color: #e6aa3a;
  }
`;

export const EditButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;

  &:hover {
    background: #e6aa3a;
    color: #111;
  }
`;

export const VipToggleButton = styled.button`
  background: ${(props) =>
    props.isVip ? "rgba(231, 76, 60, 0.1)" : "rgba(230, 170, 58, 0.1)"};
  border: 1px solid ${(props) => (props.isVip ? "#e74c3c" : "#E6AA3A")};
  color: ${(props) => (props.isVip ? "#e74c3c" : "#E6AA3A")};
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: ${(props) => (props.isVip ? "#e74c3c" : "#E6AA3A")};
    color: #111;
    transform: scale(1.05);
  }
`;

export const Footer = styled.footer`
  padding: 20px 30px;
  background: #252525;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  flex-shrink: 0;
`;

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

export const UsernameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .username-input {
    flex-grow: 1;
  }
`;

export const VerifyButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s;

  &:hover {
    background: #f7b74a;
  }
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;

  color: ${({ status }) => {
    if (status === "available") return "#2ecc71";
    if (status === "taken") return "#e74c3c";
    return "#f1c40f";
  }};

  .spinner {
    animation: ${spin} 1s linear infinite;
  }
`;
